import { takeLatest, takeEvery, select, call, put } from 'redux-saga/effects';
import * as cnt from '../../../stores/profile/company/profile-constants';
import * as locCnt from '../../../stores/profile/location/location-constants'
import { apiSaga } from '../../../sagas';
import { profile as profileApis, account as accountApi } from '../../../api';
import { delay } from "redux-saga";
import R, { pathOr } from 'ramda';

function* doUpdateGroup({ type, payload }) {
  yield* apiSaga(type, profileApis.updateGroup, [payload]);
}

function* refreshProfile() {
  const pathname = window.location.pathname;
  if (pathname === '/profile') {
    yield* apiSaga(cnt.GET_PROFILE, profileApis.getCompanyProfile, []);
  } else if (pathname.indexOf('/profile/locations') > -1) {
    const locationId = R.last(R.split('/', pathname));
    yield* apiSaga('GET_USER_LOCATION_PROFILE', profileApis.getUserLocationProfile, [{ locationId }]);
  }
}

function* doDeleteGroup({ type, payload }) {
  const confirmed = window.confirm(`Are you sure you want to delete this group? Note: items won't be deleted.`)
  if (confirmed) {
    yield* apiSaga(type, profileApis.deleteGroup, [payload]);
  }
}

function* reorderLocations({ type, payload }) {
  yield* apiSaga(type, profileApis.reorderLocations, [payload.locationIds]);
}

function* reorderProducts({ type, payload }) {
  yield* apiSaga(type, profileApis.reorderProducts, [payload.productIds]);
}

function* doGetVerified({ type }) {
  window.open('https://www.tourconnect.com/tc-verified/');
  yield* apiSaga(type, accountApi.sendNotification, [{ action: 'getVerified' }]);
}

function* doNotifyUpgrade({ type, payload }) {
  const name = pathOr('', ['name'], payload)
  if (/(.+)Upgrade Click$/.test(name)) {
    yield* apiSaga(type, accountApi.sendNotification, [{ action: 'clickedUpgrade' }]);
  }
}

export default [
  takeLatest(cnt.UPDATE_GROUP, doUpdateGroup),
  takeLatest(`${cnt.UPDATE_GROUP}_SUCCESS`, refreshProfile),
  takeLatest(cnt.DELETE_GROUP, doDeleteGroup),
  takeLatest(`${cnt.DELETE_GROUP}_SUCCESS`, refreshProfile),
  takeLatest(cnt.REORDER_LOCATIONS, reorderLocations),
  takeLatest(`${cnt.REORDER_LOCATIONS}_SUCCESS`, refreshProfile),
  takeLatest(cnt.REORDER_PRODUCTS, reorderProducts),
  takeLatest(`${cnt.REORDER_PRODUCTS}_SUCCESS`, refreshProfile),
  takeLatest(cnt.IMPORTED_LOC, refreshProfile),
  takeLatest(locCnt.FINISHED_IMPORTING_PROD, refreshProfile),
  takeLatest('{profile} getVerified', doGetVerified),
  takeLatest('TRACK_EVENT', doNotifyUpgrade),
];



// WEBPACK FOOTER //
// ./src/app/components/profile/__storeFiles__/saga.js